// Головна сторінка сайту
// src/main_page/MainPage.jsx
import React from "react";
import MainHero from "./MainHero";
import TrustedCompanies from "./TrustedCompanies";
import OurServices_2 from './OurServices_2'
import Benefits from "./Benefits";
import TestimonialsMap from "./TestimonialsMap";
import OurServices from "./OurServices";
import ContactCta from "./ContactCta";
import CaseStudies from "./CaseStudies";
import Footer from "../../pages/Footer";
import TrustedCompaniesHeader from "./TrustedCompaniesHeader";
import TrustedStatsCard from "./TrustedStatsCard";

import Reveal from "../../components/Reveal";

export default function MainPage() {
  return (
    <>
      {/* Hero може мати власні анімації всередині */}
      <MainHero />
      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <OurServices_2 />
      </Reveal>
      {/* Секції з мʼяким reveal при скролі */}
      <Reveal as="section" variant="fade" duration={0.8} threshold={0.12}>
        <Benefits />
      </Reveal>

      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <TrustedCompaniesHeader />
      </Reveal>

      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <TrustedStatsCard />
      </Reveal>

      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <CaseStudies />
      </Reveal>

      {/* <Reveal as="section" variant="up" delay={0.06}>
        <TestimonialsMap />
      </Reveal> */}

      {/* <Reveal as="section" variant="up" delay={0.12}>
        <OurServices />
      </Reveal>*/}

      <Reveal as="section" variant="zoom" delay={0.08}>
        <ContactCta />
      </Reveal>

      <Reveal as="footer" variant="fade" delay={0.1}>
        <Footer />
      </Reveal>
    </>
  );
}
